import { render, staticRenderFns } from "./CoordinateApointment.vue?vue&type=template&id=0562ad78&scoped=true"
import script from "./CoordinateApointment.vue?vue&type=script&lang=js"
export * from "./CoordinateApointment.vue?vue&type=script&lang=js"
import style0 from "./CoordinateApointment.vue?vue&type=style&index=0&id=0562ad78&prod&lang=css"
import style1 from "./CoordinateApointment.vue?vue&type=style&index=1&id=0562ad78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562ad78",
  null
  
)

export default component.exports